import React from 'react';

import { styled } from '@compiled/react';
import { useIntl } from 'react-intl';

import { fg } from '@atlaskit/platform-feature-flags/fg';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';
import { token } from '@atlaskit/tokens';
import { ScribbleBar } from '@atlassian/guard-redaction-ui/scribble';

import messages from './messages';

const redactionBarStyles = xcss({
	display: 'inline-flex',
	aspectRatio: '3.4/1',
	height: '1lh',
	'@supports not (height: 1lh)': {
		height: '1.5em',
	},
	backgroundColor: 'color.background.neutral.bold.pressed',
	verticalAlign: 'middle',
	position: 'relative',
	// Redacted content must not be selectable/copyable.
	userSelect: 'none',
});

export function RedactionMarker(): React.JSX.Element {
	const { formatMessage } = useIntl();

	if (fg('platform_editor_redaction_shared_scribble')) {
		return <ScribbleBar background="light" />;
	}
	if (fg('jira-redaction-accessibility-followup')) {
		return <RedactionBar aria-label={formatMessage(messages.redactionMarker)} />;
	}
	return <Box as="span" xcss={redactionBarStyles} />;
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const RedactionBar = styled.span({
	display: 'inline-flex',
	aspectRatio: '3.4/1',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
	height: CSS.supports('height', '1lh') ? '1lh' : '1.5em',
	backgroundColor: token('color.text'),
	verticalAlign: 'middle',
	position: 'relative',
	// Redacted content must not be selectable/copyable.
	userSelect: 'none',
});
